'use client';
import { FC, Fragment } from 'react';
import styles from './BreadCrumbs.module.scss';
import Link from 'next/link';

interface BreadCrumbsProps {
  className?: string;
  links: { title: string; link: null | string }[];
}

const BreadCrumbs: FC<BreadCrumbsProps> = ({ className = '', links }) => {
  return (
    <div className={`${styles.root} ${className}`}>
      {links.map((elem) =>
        elem.link ? (
          <Fragment key={elem.title}>
            <Link className={styles.link} href={elem.link} prefetch={false}>
              {elem.title}
            </Link>
            <p className={styles.link}>/</p>
          </Fragment>
        ) : (
          <p className={styles.text} key={elem.title}>
            {elem.title}
          </p>
        ),
      )}
    </div>
  );
};

export default BreadCrumbs;
